import { camelCase, snakeCase } from 'lodash';


export const isObjectEmpty = (value: any) => {
  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return false;
};

export const cleanObject = (obj: Record<any, any>) => {
  return Object.keys(obj).reduce<Record<string, any>>((newObj, key) => {
    if(![null, undefined, ''].includes(obj[key])) {
      newObj[key] = obj[key];
    }
    return newObj;
  }, {});
};

const processObjectKeyValue = (value: any, func: (value: any) => any): any => {

  if (!value) {
    return value;
  }

  if (value instanceof File) {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map((v) => processObjectKeyValue(v, func));
  }

  if (typeof value === 'object') {
    return func(value);
  }

  return value;
};

export const camelizeObject = <T>(obj: Record<string, any>): T => {
  // @ts-ignore
  return Object.keys(obj).reduce(
    (result, key) => ({
      ...result,
      [camelCase(key)]: processObjectKeyValue(obj[key], camelizeObject),
    }),
    {},
  );
};

/**
 * Camelize an object, leaving the keys DIRECTLY under any key listed in
 * `parentKeyToSkip` untouched (their values are still camelized recursively).
 * Used for API payloads where `answer_data` keys are survey field
 * identifiers that must never be re-cased. Ported from coolset-react-app.
 */
export const camelizeObjectWithExclusions = <T extends object>(
  obj: T,
  parentKeyToSkip?: string[],
  isSkipLevel?: boolean,
): Record<string, any> => {
  const result: Record<string, any> = {};

  for (const key of Object.keys(obj)) {
    const camelKey = isSkipLevel ? key : camelCase(key);
    result[camelKey] = processObjectKeyValue(
      (obj as Record<string, unknown>)[key],
      (val: Record<string, unknown>) =>
        camelizeObjectWithExclusions(
          val,
          parentKeyToSkip,
          parentKeyToSkip?.includes(key),
        ),
    );
  }

  return result;
};

export const snakizeObject = <T>(obj: Record<string, any>): T => {
  // @ts-ignore
  return Object.keys(obj).reduce(
    (result, key) => ({
      ...result,
      [snakeCase(key)]: processObjectKeyValue(obj[key], snakizeObject),
    }),
    {},
  );
};